<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search bpm-approval-process">
        <div class="section">
          <el-form
            label-position="left"
            label-width="120px"
          >
            <div class="el-form-item-wrapper" style="display: flex">
              <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
                <el-input v-model="form.tenantName" style="width: 150px;padding-left: 10px" clearable />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.ManifestChannel')" style="padding-left: 10px">
                <el-select v-model="form.manifestChannel" style="width: 150px;" clearable>
                  <el-option v-for="(item,index) in VAS_CHANNEL_ONE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.VGMChannel')" style="padding-left: 10px">
                <el-select v-model="form.vgmChannel" style="width: 150px;" clearable>
                  <el-option v-for="(item,index) in VAS_CHANNEL_ONE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                </el-select>
              </el-form-item>
              <div style="padding-left: 10px">
                <el-button type="primary" @click="queryHandler">
                  {{ $t('CargoMsg.Cargo_Query') }}
                </el-button>
                <el-button type="primary" @click="addHandler">
                  {{ $t('CargoMsg.Cargo_Add') }}
                </el-button>
                <el-button type="primary" @click="editHandler">
                  {{ $t('CargoMsg.Cargo_Edit') }}
                </el-button>
                <el-button type="danger" @click="deleteHandler">
                  {{ $t('CargoMsg.Cargo_OrderDelete') }}
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          style="width: 100%;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 新增编辑弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="settingDialog.visible"
      :title="$t('CargoMsg.AE_IDENTIFY_VENDORS')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="130px" label-position="right">
          <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
            <cargo-advance-select
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              callback-method-type="obj"
              :default-value="String(settingDialog.form.tenant)||''"
              @parentCallBack="changeTenant"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.ManifestChannel')">
            <el-select v-model="settingDialog.form.manifestChannel">
              <el-option v-for="(item,index) in VAS_CHANNEL_TWO" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.VGMChannel')">
            <el-select v-model="settingDialog.form.vgmChannel">
              <el-option v-for="(item,index) in VAS_CHANNEL_TWO" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="settingDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { VAS_CHANNEL_ONE, VAS_CHANNEL_TWO } from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getName, getStateByCode } from '@/class/cargo/model/parameters/CommonState'
import { deleteVasChannelFunc, getVasChannelList, saveVasChannelFunc } from '@/api/sysManage/baseConfig/vasChannelConfig'

export default {
  name: 'VASChannelSetting',
  components: {
    CargoAdvanceSelect
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      VAS_CHANNEL_ONE,
      VAS_CHANNEL_TWO,
      selectTypeNames: TYPE_NAMES,
      ColumnUtils,
      loading: false,
      currentExpress: null,
      selectedRow: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      form: {
        tenantName: '',
        manifestChannel: '',
        vgmChannel: ''
      },
      settingDialog: {
        title: this.$t('CargoMsg.Cargo_Add'),
        visible: false,
        form: {
          uuid: '',
          version: 0,
          tenant: '',
          tenantName: '',
          manifestChannel: '',
          vgmChannel: ''
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: 'TenantId',
          field: 'tenant',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.TENANT_BUSINESS_NAME'),
          field: 'tenantName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.ManifestChannel'),
          field: 'manifestChannel',
          width: 200,
          valueFormatter: params => {
            const state = getStateByCode(VAS_CHANNEL_ONE, params.value)
            return getName(state)
          }
        }, {
          headerName: this.$t('CargoMsg.VGMChannel'),
          field: 'vgmChannel',
          width: 200,
          valueFormatter: params => {
            const state = getStateByCode(VAS_CHANNEL_ONE, params.value)
            return getName(state)
          }
        }
      ],
      gridApi: null
    }
  },
  created() {
    this.queryHandler()
  },
  methods: {
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedRow = node.data
          }
        })
      }
    },
    queryHandler() {
      this.loading = getLoading4Cxt()
      const data = {
        anyStr1: this.form.tenantName,
        anyInteger1: this.form.manifestChannel !== 'all' ? this.form.manifestChannel : null,
        anyInteger2: this.form.vgmChannel !== 'all' ? this.form.vgmChannel : null
      }
      getVasChannelList(data).then(res => {
        if (res.data) {
          this.rowData = res.data
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.settingDialog.form = {
        uuid: '',
        version: 0,
        tenant: '',
        tenantName: '',
        manifestChannel: '',
        vgmChannel: ''
      }
      this.settingDialog.visible = true
    },
    editHandler() {
      if (!this.selectedRow || this.selectedRow.length === 0) {
        this.$message.warning(this.$t('CargoMsg.VASChannelFormEditTip'))
        return
      }
      this.settingDialog.form = { ...this.selectedRow }
      this.settingDialog.visible = true
    },
    deleteHandler() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.VASChannelFormDeleteTip'))
        return
      }
      this.$confirm(this.$t('CargoMsg.VASChannelDeleteTip'), this.$t('CargoMsg.VASChannelDTip'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt()
        const data = {
          keys: Array.from(selectedRows, p => p.uuid)
        }
        deleteVasChannelFunc(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.queryHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    saveHandler() {
      const form = { ...this.settingDialog.form }
      if (!form.tenant) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.TENANT_BUSINESS_NAME'))
        return
      }
      if (!(form.manifestChannel || form.vgmChannel)) {
        this.$message.warning(this.$t('CargoMsg.VASChannelSelectOneTip'))
        return
      }
      this.loading = getLoading4Cxt()
      form.tenant = Number(this.settingDialog.form.tenant)
      saveVasChannelFunc(form).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.settingDialog.visible = false
          this.queryHandler()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    changeTenant(p) {
      this.settingDialog.form.tenant = p.value
      this.settingDialog.form.tenantName = p.name
    }
  }
}
</script>

<style lang="scss" scoped>

#app /deep/ .el-form-item__label {
  text-align: right;
}

</style>
